angular.module('Itao.IndicatorMap').directive('gridContainer', ['$timeout', 'mapConfig', function($timeout, mapConfig) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'gridContainer.html',
    controller: 'GridController',
    scope: {
      onChange: '&',
      onDragStart: '&',
      onDragStop: '&',
      onResizeStart: '&',
      onResizeStop: '&',
      options: '=',
      diagramData: '=',
      config: '=',
      selectDistrict: '&',
      deselectDistrict: '&'
    },
    controllerAs: 'ctrl',
    link: function (scope, element, attrs, controller) {
      scope.config = scope.config || {};
      scope.config.grids = scope.config.grids || {};

      element.on('change', function (e, items) {
        $timeout(function() {
          scope.$apply();
          scope.onChange({event: e, items: items});
        });
      });

      element.on('dragstart', function(e, ui) {
        scope.onDragStart({event: e, ui: ui});
      });

      element.on('dragstop', function(e, ui) {
        $timeout(function() {
          scope.$apply();
          scope.onDragStop({event: e, ui: ui});
        });
      });

      element.on('resizestart', function(e, ui) {
        scope.onResizeStart({event: e, ui: ui});
      });

      element.on('resizestop', function(e, ui) {
        $timeout(function() {
          scope.$apply();
          scope.onResizeStop({event: e, ui: ui});
        });
      });

      // Init gridstack container
      scope.gridstackHandler = controller.init(element, scope.options);
    }
  };

}]);
angular.module('Itao.IndicatorMap').directive('gridItem', ['$timeout', '$http', 'mapConfig', 'GridItemWidgetCompiler', 'ExportService', function($timeout, $http, mapConfig, GridItemWidgetCompiler, ExportService) {
  'use strict';
  return {
    restrict: 'E',
    templateUrl: mapConfig.templateBasePath + 'gridItem.html',
    controller: 'GridController',
    //it needs the grid container's controller instance since the gridstack initialization is done inside it
    require: '^gridContainer',
    scope: {
      config: '=',
      diagramData: '=',
      gridItemName: '@',
      selectDistrict: '&',
      deselectDistrict: '&'
    },
    link: function (scope, element, attrs, controller) {
      scope.config = scope.config || {};
      scope.config.widget = scope.config.widget || {};
      var $contentContainer = element.find('.grid-stack-item-content');
      // If type is specified, compile, render and append widget
      if (scope.config.type) {
        $contentContainer.addClass('grid-stack-item-content-' + scope.config.type);
        var widgetTemplateFunction = GridItemWidgetCompiler.generateTemplateFunctionByType(scope.config.type, scope.config);
        $contentContainer.append(widgetTemplateFunction(scope));
      }

      jQuery(element).attr('data-gs-x', scope.config.x);
      jQuery(element).attr('data-gs-y', scope.config.y);
      jQuery(element).attr('data-gs-width', scope.config.width);
      jQuery(element).attr('data-gs-height', scope.config.height);

      var unwatchX = scope.$watch(function(){
        return jQuery(element).attr('data-gs-x');
      }, function(val) {
        scope.config.x = val;
      });

      var unwatchY = scope.$watch(function(){
        return jQuery(element).attr('data-gs-y');
      }, function(val) {
        scope.config.y = val;
      });

      scope.$watch(function(){
        return jQuery(element).attr('data-gs-width');
      }, function(val) {
        scope.config.width = val;
      });

      scope.$watch(function(){
        return jQuery(element).attr('data-gs-height');
      }, function(val) {
        scope.config.height = val;
      });

      scope.decreaseWidgetHeight = function() {
        controller.decreaseWidgetHeight(element);
      };

      scope.increaseWidgetHeight = function() {
        controller.increaseWidgetHeight(element);
      };

      scope.removeWidget = function() {
        scope.$destroy();
        controller.removeItem(element);
        controller.removeFromCollection(scope.gridItemName);
      };
      scope.exportWidget = function(type) {
        ExportService.exportAsImage(
          $contentContainer.html(),
          type,
          'hyperion-export',
          [Math.ceil($contentContainer.width()), Math.ceil($contentContainer.height())]
        );
      };

      element.bind('$destroy', function() {
        unwatchY();
        unwatchX();
        scope.$destroy();
      });

      // Initialize directive as gridstack element
      controller.makeWidget(element);

    }

  };

}]);
